import React from 'react'
import { useTranslation } from 'react-i18next'
import { DetailRow } from '@pandiafi/components'

import { User } from '../../../common/validations'
import {
  InvoiceAddress,
  InvoiceAddressType,
} from '../../../common/validations/invoiceAddress'
import { useModuleConfig } from '../../hooks/useModuleConfig/useModuleConfig'

export const UserInfoView = ({
  user,
  invoiceAddress,
}: {
  user: User
  invoiceAddress?: InvoiceAddress | null
}) => {
  const { t } = useTranslation(['common'])
  const {
    userInfo: { showCommunicationPreferences },
  } = useModuleConfig()

  const getCommunicationWays = () => {
    const communications = []
    if (user.communicationByEmail) {
      communications.push(t('common:communicationByEmail'))
    }
    if (user.communicationBySms) {
      communications.push(t('common:communicationBySms'))
    }
    return communications
  }

  return (
    <DetailRow>
      <DetailRow.Item title={t('common:residentId')}>
        {user.cognitoId || null}
      </DetailRow.Item>
      <DetailRow.Item title={t('common:emailForContact')}>
        {user.email || null}
      </DetailRow.Item>
      <DetailRow.Item title={t('common:phone')}>
        {user.phoneNumber || null}
      </DetailRow.Item>
      {showCommunicationPreferences && (
        <DetailRow.Item title={t('common:waysToCommunicate')}>
          {getCommunicationWays().map((communication) => (
            <span key={communication}>{communication}</span>
          ))}
        </DetailRow.Item>
      )}
      <DetailRow.Item title={t('common:userInfo.permissionsHeader')}>
        {user.marketingAllowed ? t('common:marketingAllowed') : null}
      </DetailRow.Item>
      {invoiceAddress?.postalInvoiceAddress && (
        <DetailRow.Item title={t('common:paperInvoice')}>
          {invoiceAddress.postalInvoiceAddress.invoiceRecipientName && (
            <span>
              {invoiceAddress.postalInvoiceAddress.invoiceRecipientName}
            </span>
          )}
          <span>{invoiceAddress.postalInvoiceAddress.streetAddressLine1}</span>
          {invoiceAddress.postalInvoiceAddress.streetAddressLine2 && (
            <span>
              {invoiceAddress.postalInvoiceAddress.streetAddressLine2}
            </span>
          )}
          <span>
            {invoiceAddress.postalInvoiceAddress.postalCode}{' '}
            {invoiceAddress.postalInvoiceAddress.city}
          </span>
        </DetailRow.Item>
      )}
      {invoiceAddress?.selectedInvoiceType ===
        InvoiceAddressType.CORPORATE_ELECTRONIC && (
        <DetailRow.Item title={t('common:eInvoice')}>
          {t('common:inUse')}
        </DetailRow.Item>
      )}
    </DetailRow>
  )
}
